import { AccessPermissions } from '@circlefin/permissions'

import type { PermissionSet } from '@circlefin/permissions'

export const ROLR_SECTION: PermissionSet = {
  access: AccessPermissions.publicOnly,
}
